import { render, staticRenderFns } from "./DispositionRepresentative.vue?vue&type=template&id=0c6d1965&scoped=true&lang=pug&"
import script from "./DispositionRepresentative.vue?vue&type=script&lang=ts&"
export * from "./DispositionRepresentative.vue?vue&type=script&lang=ts&"
import style0 from "./DispositionRepresentative.vue?vue&type=style&index=0&id=0c6d1965&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d1965",
  null
  
)

export default component.exports